module.exports = __webpack_public_path__ + "static/media/activeDot.29d475a3.svg";